import { render, staticRenderFns } from "./cartOrderAddressItem.vue?vue&type=template&id=63d33b82&"
import script from "./cartOrderAddressItem.vue?vue&type=script&lang=js&"
export * from "./cartOrderAddressItem.vue?vue&type=script&lang=js&"
import style0 from "./cartOrderAddressItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports